"use strict";
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AssertionError = void 0;
exports.assert = assert;
/**
 * A subclass of `Error` that indicates the failure of an assertion.
 */ var AssertionError = /*#__PURE__*/ function(Error1) {
    _inherits(AssertionError, Error1);
    function AssertionError(message) {
        _class_call_check(this, AssertionError);
        var _this;
        _this = _call_super(this, AssertionError, [
            "Wrong assertion encountered".concat(message ? ': "'.concat(message, '"') : '', "!")
        ]);
        _this.name = 'AssertionError';
        return _this;
    }
    return AssertionError;
}(_wrap_native_super(Error));
/**
 * Function that throws {@linkcode AssertionError} (with optional message defined with `errorMessage`) if
 * `condition` is falsy.
 * You can use it to narrow types:
 *
 * ```TypeScript
 * interface Foo {
 *   kind: 'Foo';
 * }
 *
 * interface Bar {
 *   kind: 'Bar';
 * }
 *
 * declare const foobar: Foo | Bar;
 *
 * assert(is<Foo>(foobar, foobar.kind === 'Foo'));
 *
 * // `typeof foobar` is now `Foo`
 * ```
 *
 * @param condition Condition we're asserting isn't falsy
 * @param errorMessage Message for the `AssertionError`
 */ exports.AssertionError = AssertionError;
function assert(condition, errorMessage) {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- we don't mind here
    if (!condition) {
        throw new AssertionError(errorMessage);
    }
} //# sourceMappingURL=assert.js.map
